import axios from "axios";
import { Base_URL } from "../url";

export const fetchUserAttendance = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/SalaryProcess/UserAttendenceGet/${id}`);
   // const response = await axios.get("https://192.168.29.243:7039/api/SalaryProcess/UserAttendenceGet");
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching user attendance!";
  }
};